/* import classNames from 'classnames'; */
const host = process.env.REACT_APP_SERVER_API_URL || 'http://localhost';

export const version = '4.1.0';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
 isFluid: true,
 isRTL: false,
 isDark: false,
 navbarPosition: 'vertical',
 showBurgerMenu: false, // controls showing vertical nav on mobile
 currency: '$',
 isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
 navbarStyle: 'transparent'
};

export const states = [
 { val: 'und', tag: 'Invalido', icon: 'ban', bg: 'light', color: 'dark' },
 { val: 1, tag: 'Disponible', icon: 'check', bg: 'success', color: 'success' },
 { val: 2, tag: 'Activo', icon: 'check', bg: 'success', color: 'success' },
 { val: 3, tag: 'Pendiente', icon: 'sync', bg: 'primary', color: 'primary' },
 { val: 4, tag: 'Inactivo', icon: 'ban', bg: 'danger', color: 'danger' },
 { val: null, tag: 'Indefinido', icon: 'ban', bg: 'dark', color: 'dark' }
];

export const config = {
 PUBLIC_URL: process.env.PUBLIC_URL || '/',
 REACT_APP_DESCP: process.env.REACT_APP_DESCP || 'Inmovili',
 REACT_APP_NAME: process.env.REACT_APP_NAME || 'Inmovili',
 REACT_APP_DESCP_HOME: process.env.REACT_APP_DESCP_HOME || 'Inmovili',
 REACT_APP_SLOGAN: ['Todo', 'el cuidado', 'el amor', 'el afecto', 'de tu mascota en un solo lugar.']
};

const newPath = (path, params = []) => {
 const url = [host, 'api', path].join('/');
 if (params.length || !!params[0]) return [url, params.join('/')].join('/');
 return url;
};

export const urls = {
 company: `${host}/api/company`,
 project: `${host}/api/project`,
 user: params => newPath('user', params),
 companies: params => newPath('company', params),
 whatsapp: params => newPath('whatsapp', params),
 projects: params => newPath('project', params),
 articles: params => newPath('article', params),
 products: params => newPath('product', params),
 order: params => newPath('order', params),
 offer: params => newPath('offer', params),
 taxe: params => newPath('taxe', params),
 queries: params => newPath('queries', params),
 payment: params => newPath('payment', params),
 route: params => newPath('route', params),
 person: params => newPath('person', params),
 service: params => newPath('service', params),
 contract: params => newPath('contract', params),
 settings: params => newPath('settings', params),
 auths: params => newPath('auth', params),
 auth: {
  validateToken: `${host}/api/auth/validate`,
  login: `${host}/api/auth/signin`,
  googlelogin: `${host}/api/auth/googlelogin`,
  facebooklogin: `${host}/api/auth/facebooklogin`,
  signup: `${host}/api/auth/signup`,
  googlesignup: `${host}/api/auth/googlesignup`,
  facebooksignup: `${host}/api/auth/facebooksignup`,
  logout: `${host}/api/auth/logout`,
  whoami: `${host}/api/auth/whoami`,
  reset: `${host}/api/auth/reset-password`,
  forgot: `${host}/api/auth/forgot-password`
 },
 services: `${host}/api/services`,
 setting: `${host}/api/settings`,
 symbols: `${host}/api/symbols`,
 exchange: `${host}/api/exchange`,
 /* order: r =>
     classNames(`${host}/api/order`, {
      [`/${r.symbol}`]: r.symbol,
      '?': r.page || r.size,
      [`page=${r.page}`]: r.page,
      '&': r.page && r.size,
      [`size=${r.size}`]: r.size,
      '/sync': r.sync,
      [`/${r.beholderOrderId}`]: r.beholderOrderId
     }).replace(/ /g, ''), */
 images: r => `${host}/api/images/${r}`
};

export const firebase = {
 apiKey: 'AIzaSyAcStJNOJ-3jevCw1EduaoRzBvgeM21KSI',
 authDomain: 'inmovilii.firebaseapp.com',
 projectId: 'inmovilii',
 storageBucket: 'inmovilii.appspot.com',
 messagingSenderId: '91383063458',
 appId: '1:91383063458:web:5953aef339c55d29f008fb'
};

export const authGoogle = {
 client_id: '507835578448-tcsk19bgg5df3p45suqsq1q936vkqoa6.apps.googleusercontent.com',
 project_id: 'inmovili-341717',
 auth_uri: 'https://accounts.google.com/o/oauth2/auth',
 token_uri: 'https://oauth2.googleapis.com/token',
 auth_provider_x509_cert_url: 'https://www.googleapis.com/oauth2/v1/certs',
 client_secret: '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',
 javascript_origins: ['http://localhost:4000', 'https://inmovili.com']
};

export default {
 version,
 navbarBreakPoint,
 topNavbarBreakpoint,
 settings,
 urls,
 config
};
